import { all, put, fork, call, take } from "redux-saga/effects"
import { isEmpty } from "lodash"

import CONFIG from "core/config"

import {
  GET_PARCEL,
  GET_PARCEL_REQUEST,
  GET_PARCEL_SUCCESS,
  GET_PARCEL_FAILURE,
  GET_PARCEL_CANCEL,
} from "data/constants"

import { get } from "data/fetch/parcels/single"

function* getParcel() {
  while (true) {
    const action = yield take(GET_PARCEL)
    yield put({ type: GET_PARCEL_REQUEST })
    try {
      const { data } = yield call(() => get(action.number))

      if (isEmpty(data.items[0])) {
        throw Error("NOT_FOUND")
      }

      const item = data.items[0]
      if (item.glopal_tracking_available) {
        const redirectTo = `${CONFIG.glopalRedirectUrl}/parcel/${item.tracking_number}`
        window.location.assign(redirectTo)
      }

      yield put({
        type: GET_PARCEL_SUCCESS,
        data: data.items[0],
      })
    } catch (error) {
      yield put({ type: GET_PARCEL_FAILURE, error })
    }
  }
}

export default function* main() {
  while (true) {
    const tasks = yield all([
      fork(getParcel),
    ])

    yield all(tasks)

    yield take(GET_PARCEL_CANCEL)
    yield tasks.map(task => task.cancel())
  }
}



// WEBPACK FOOTER //
// ./src/data/sagas/parcels/single.js